import LogoPNG from '../icons/LOGO.png'

export const integrations = [
    { name: 'Artos', status: 'Select from Library', img: LogoPNG },
]